import { FrameBody, Wait } from "@npd-ng/adp-benchmark"
import { Content } from "../types/Content";
import { useStateContext } from "../hooks/useStateContext";
import {  useResolveServiceStatus } from "../hooks/useNetworkService";
import { actions } from "../state";
import { useDedupEffect } from "../util/useDedupEffect";
export default function ConnectionCheckView(){
  const { state, dispatch } = useStateContext();
  const {checkNCSeServerAvailability, checkOnlineServerAvailability} = useResolveServiceStatus(dispatch);
  const content= state.staticContent as Content;
  const notifications = content.notifications;
  useDedupEffect(()=>{
    if(state.sessionState.selectedAssessmentMode === "online"){
         checkOnlineServerAvailability().then((isConnectionAvailable)=>{
           if(isConnectionAvailable){
            dispatch(actions.createSetViewAction(state.sessionState.lastKnownGoodState));
           }
         })
        
     }
     else if(state.sessionState.selectedAssessmentMode === "ncs"){
         checkNCSeServerAvailability().then((isConnectionAvailable)=>{
          if(isConnectionAvailable){
            dispatch(actions.createSetViewAction(state.sessionState.lastKnownGoodState));
           }
         })
     } 
    
     },[])
    return (
       <div>
       <FrameBody> 
        <div className="loadingWaitview">
        <Wait title={notifications.internetConnecting}/>
        </div>
        </FrameBody>
       </div>
    )
}